import AppointmentForm from '../components/AppointmentForm';

const AppointmentPage = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-gray-800 mb-8 text-center">Programare Online</h1>
      
      <div className="max-w-2xl mx-auto bg-white rounded-lg shadow-md p-6">
        <AppointmentForm />
      </div>
    </div>
  );
};

export default AppointmentPage;
